import { Rating } from 'fronton-react';
import React from 'react';

export type ReviewRatingScoreProps = {
  ratingValue: number;
};

export const ReviewRatingScore: React.FC<ReviewRatingScoreProps> = ({ ratingValue }) => {
  const isRatingValid = ratingValue >= 0 && ratingValue <= 5;

  return <>{isRatingValid && <Rating value={ratingValue} size="l" data-qa="rating-value" />}</>;
};
